export default {
	'generate-report': 'Generate report',
	'confirm-receiving': 'Confirm purchasing',
	'preview-receiving': 'Preview purchasing',
	'edit-receiving': 'Edit purchasing',
	pending: 'Pending',
	receive: 'Purchase',
	received: 'Purchased',
	'inventory-report': 'Inventory report',
	'export-as-excel': 'Export as Excel',
	purchase: 'Offer',
	quintal: 'Quintal',

	'average-purchases': 'Average price',
	'sum-purchases': 'Sum purchases',
	'total-purchases-weights': 'Total purchases weights',
}